import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { AddressModel } from "../../customers/models/AddressModel";
import { PhoneModel } from "../../home/models/ContactInfo";
import { PaymentType } from "../../payments/models/PaymentModels";
import { BasicSubmitOrderModel, CheckoutSummaryModel, OrderConfirmModel, SubmitOrderModel } from "../models/OrderModel";
import { OrderService } from "../services/OrderService";

export default function useCheckoutVM(cartId: number) {
    const service = new OrderService();

    //const [address, setAddress] = useState<AddressModel | undefined>(undefined);
    //const [phone, setPhone] = useState<PhoneModel | undefined>(undefined);
    const [summary, setSummary] = useState<CheckoutSummaryModel | undefined>(undefined);

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [showAddressBook, setShowAddressBook] = useState(false);
    const [showPhoneBook, setShowPhoneBook] = useState(false);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmedModel, setConfirmedModel] = useState<OrderConfirmModel | undefined>(undefined);

    const getSummary = () => {
        const onResult = (result: IDataResult) => {
            const summary = result.data as CheckoutSummaryModel;
            if (summary) {
                setSummary(summary);
            }

            setLoading(false);
        }

        setLoading(true);
        setSummary(undefined);

        const request = service.getCheckoutSummary(cartId);
        DataUtils.onRequest(request, onResult);
    }

    const submitOrder = () => {
        if (!summary) return;

        setSubmitting(true);

        const onResult = (result: IDataResult) => {
            const confirmedModel = result.data as OrderConfirmModel;

            if (result.status === ResponseStatus.success && confirmedModel) {
                setShowConfirmation(true);
                setConfirmedModel(confirmedModel);
            }
        }

        const model: BasicSubmitOrderModel = {
            cartId: cartId,
            addressId: summary.address?.id,
            phoneId: summary.phone?.id,
            payments: summary.payments,
        }

        const request = service.submitOrder(model);
        DataUtils.onRequest(request, onResult, false);
    }

    const getPaymentWithoutPoints = () => {
        if (!summary) return [];

        return summary.payments.filter((payment) => payment.type !== PaymentType.earningPoint);
    }

    const getTotalPointsPaymentAmount = () => {
        if (!summary) return 0;

        return summary.payments
            .filter((payment) => payment.type === PaymentType.earningPoint)
            .reduce((sum, payment) => sum + payment.amount, 0);
    }

    return {
        //address,
        //phone,
        summary, setSummary,

        submitting,
        loading,

        showAddressBook, setShowAddressBook,
        showPhoneBook, setShowPhoneBook,

        showConfirmation, setShowConfirmation,
        confirmedModel,

        getSummary,
        submitOrder,
        getPaymentWithoutPoints,
        getTotalPointsPaymentAmount
    }
}